export const ORDER_LOAD_SUCCESS = 'ORDER_LOAD_SUCCESS';
export const ORDER_LOAD_FAIL = 'ORDER_LOAD_FAIL';
export const ORDER_IS_LOADING = 'ORDER_IS_LOADING';
export const ORDER_DOCUMENTS_LOAD = 'ORDER_DOCUMENTS_LOAD';
export const DISABLE_INVOICE = 'DISABLE_INVOICE';
export const ORDER_COMPLETION_CLEAR = 'ORDER_COMPLETION_CLEAR';

export const CLEAR_ORDER_COMPLETION_STATE = '[ORDER COMPLETION] CLEAR_STATE';

export class DisableInvoice {
  readonly type = DISABLE_INVOICE;
  constructor() {}
}
export class OrderCompletionClear {
  readonly type = ORDER_COMPLETION_CLEAR;
  constructor() {}
}

export class OrderLoadSuccess {
  readonly type = ORDER_LOAD_SUCCESS;
  constructor(public payload: {data: any}) {}
}

export class OrderLoadFail {
  readonly type = ORDER_LOAD_FAIL;
  constructor(public payload: {order_id: any}) {}
}

export class OrderIsLoading {
  readonly type = ORDER_IS_LOADING;
  constructor(public payload: {parameters: any}) {}
}

export class ClearOrderCompletionState {
  readonly type = CLEAR_ORDER_COMPLETION_STATE;
}



// WEBPACK FOOTER //
// ./src/app/store/actions/order-complition.action.ts